import './GrayTransparentBlocker.scss';
import { filterUndefined } from '../../utils/FilterUndefinedObject';

/**
 * A component for blocking user interaction on the screen
 */
const defaultProps = {
  show: false,
};

export default function GrayTransparentBlocker(props) {
  const { show } = { ...defaultProps, ...filterUndefined(props) };
  return show ? <div className='gray-transparent-blocker' /> : '';
}
